import { useState } from 'react';
const useArrayState = () => {
    const [state, setArrayState] = useState([]);

    function setArray(item) {
        const existingIndex = state.findIndex(i => i.id === item.id);
        
        if (existingIndex === -1) {
            setArrayState([...state, item])
        } else {
            state.splice(existingIndex, 1);
            setArrayState([...state])
        }
    }

    return {
        state,
        setArray
    }
}

export default useArrayState;